import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import next_btn from "app/images/next-btn.svg";
import next_btn_jp from "app/images/next-btn-jp.svg";

type BadgeType = "next" | "upcoming";

interface IProps {
  badgeType: BadgeType;
  title: string;
  bookingDate: string;
}

const SingleBooking = ({ badgeType, title, bookingDate }: IProps) => {
  const { i18n } = useTranslation();

  const renderBadge = () => {
    if (badgeType === "next") {
      const badgeSrc = i18n.language === "ja" ? next_btn_jp : next_btn;
      return <img src={badgeSrc} alt="next" className={styles.badge_img} />;
    }

    return <span className={styles.badge_text}>UPCOMING</span>;
  };

  return (
    <div className={styles.content}>
      {renderBadge()}
      <div className={styles.content_description_wrapper}>
        <p className={styles.description_title}>{title}</p>
        <p className={styles.description} dangerouslySetInnerHTML={{ __html: bookingDate }} />
      </div>
    </div>
  );
};

export default SingleBooking;
